export const STATUSES = ['Running', 'Starting', 'Ending'];
export const STATUS_RUNNING = 'RUNNING';
export const STATUS_STARTING = 'STARTING';
export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
export const MIN_DATE_YEAR = 2022;
export const MIN_DATE_MONTH = 0;
export const MIN_DATE_DAY = 1;
export const MAX_DATE_YEAR_OFFSET = 2;
